( function( global, $ ) {
    if( $('[data-select]') ) {
        $('[data-select]').each(function() {
            $(this).change(function() {
                if($(this).val()) {
                    window.location.replace($(this).val());
                }
            })
        });
    }
}( window.groots, jQuery ));